import Showcase from "./Showcase";
import TagContainer from "./TagContainer";

export default class Tag
{
	constructor(el)
	{
		this.el = el;
	}

	static className = () => "diary-day-search-edibles-showcase-tags__tag";
	static selector = () => `.${this.className()}`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("change", event => {
			const selector = `${this.selector()} input`;
			if (event.target.matches(selector)) {
				const tag = new this(event.target.closest(this.selector()));
				tag.toggle(event.target.checked).applyToggle();
			}
		});
	}

	getShowcase()
	{
		return new Showcase(this.el.closest(Showcase.selector()));
	}

	getTagContainer()
	{
		return new TagContainer(this.el.closest(TagContainer.selector()));
	}

	getId()
	{
		return parseInt(this.el.querySelector(`input`).value);
	}

	getIsChecked()
	{
		return !!this.el.querySelector(`input`).checked;
	}

	toggle(checked)
	{
		this.el.classList.toggle(`${Tag.className()}--selected`, checked);

		return this;
	}

	applyToggle()
	{
		this.getShowcase().setTags(this.getTagContainer().getTagCollection().filterChecked());

		return this;
	}

	reset()
	{
		this.el.querySelector(`input`).checked = false;

		this.toggle(false);

		return false;
	}

	hide()
	{
		this.el.hidden = true;

		return true;
	}

	show()
	{
		this.el.hidden = false;

		return true;
	}
}
